export const keyEventHandler =
	({activeIndex, listRef, floatingProps, updateValue, listItems, focusedNestedGroup, setFocusedNestedGroup}) =>
	event => {
		const checkboxHasFocus = event.target.type === 'checkbox'
		floatingProps.onKeyDown?.(event)
		// Group checkboxes use real DOM focus, while item navigation uses virtual focus on the select container.
		// Return focus to the container after navigating so the focused element and active index stay aligned.
		if (checkboxHasFocus && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
			event.currentTarget.focus({preventScroll: true})
		}

		if (!listItems.length) return // no items to select
		const activeItem = activeIndex === null ? null : listItems[activeIndex]

		if (event.key === 'Enter' && activeItem) {
			event.preventDefault()
			const {type, items: groupItems, data} = activeItem
			if (type === 'group') updateValue(groupItems) // pass all group items
			if (type === 'item') updateValue(data) // pass item data
			if (type === 'nested-group' && !focusedNestedGroup) updateValue(data.subItems) // pass nested-group data
		}

		if (event.key === 'ArrowRight' && activeItem) {
			const {data} = activeItem
			if (data.subItems) {
				setFocusedNestedGroup(activeIndex)
				event.preventDefault()
			}
		}

		if (event.key === 'ArrowLeft' && focusedNestedGroup !== null) {
			listRef.current[focusedNestedGroup]?.focus()
			setFocusedNestedGroup(null)
			event.preventDefault()
		}
	}
